'use strict';

/**
 * @classname FixCartBox
 * @classdesc 固定カートボックス
 */
export default class FixCartBox {
	/**
	 * @constructor
	 * @param {jQuery} $e - .block--fix-cart-box
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		console.log(`innerWidth is ${$(window).innerWidth()}px`);
		if($(window).innerWidth() < 992){
			this.initialize();
		}
	};


	/**
	 * 初期化（SPのみ）
	 *
	 * @memberof FixCartBox
	 * @return undefined
	 */
	initialize() {
		console.log(`${this.constructor.name}.initialize`);
		const $area = $('.area--item-detail-info');
		setTimeout(() => {
			const distance = $area.offset().top;
			console.log(`distance is ${distance}px`);
			const height = $area.innerHeight();
			console.log(`height is ${height}px`);
			this._trigger = distance + height - 240;
			console.log(`trigger is ${this._trigger}px`);
			$(window).on('scroll', () => this.onScroll());
			this.onScroll();
		},2000);
		setTimeout(() => {
			const distance = $area.offset().top;
			console.log(`distance is ${distance}px`);
			const height = $area.innerHeight();
			console.log(`height is ${height}px`);
			this._trigger = distance + height - 240;
			console.log(`trigger is ${this._trigger}px`);
			$(window).on('scroll', () => this.onScroll());
			this.onScroll();
		},4000);
	};


	/**
	 * scrollのコールバック
	 *
	 * @memberof FixCartBox
	 * @return undefined
	 */
	onScroll() {
		//console.log(`${this.constructor.name}.onScroll`);
		const $fixCartBox = $('.block--fix-cart-box');
		if($(window).scrollTop() > this._trigger){
			$fixCartBox.addClass('fixed');
		}else{
			$fixCartBox.removeClass('fixed');
		}
	};
};
